import gql from 'graphql-tag'

import { UserRoleFragment } from 'store/fragments'

// QUERIES
export const GetCompanyUsersRoles = gql`
	query _UserToCompanyRoleCollection($companyId: String) {
		_UserToCompanyRoleCollection(filter:{B:{eq:$companyId}}) {edges{node{
			...UserRoleFragment
		}}}
	}
	${UserRoleFragment}
`
export const CompanyRole = gql`
	query companyRoleCollection($id:String){
		companyRoleCollection(filter:{companyId:{eq:$id}}) {
    edges{
      node{
        id
      }
    }
  }
	}
`
// MUtATIONS
export const HandleCompanyUsersRole = gql`
	mutation handleCompanyUsersRole($data: [_UserToCompanyRoleInsertInput!]!) {
		insertInto_UserToCompanyRoleCollection(objects: $data) {
			records{...UserRoleFragment}
		}
	}
	${UserRoleFragment}
`
export const DeleteCompanyUserRole = gql`
	mutation deleteCompanyUserRole($filter:_UserToCompanyRoleFilter) {
		deleteFrom_UserToCompanyRoleCollection(filter:$filter) {
			records{...UserRoleFragment}
		}
	}
	${UserRoleFragment}
`
